import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './RecentBlogPosts.css'
import {Row, Col} from 'react-flexbox-grid'
// import format from '../../helpers/format'
// import convert from '../../helpers/convert'
import moment from 'moment'
import config from '../../config'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../'

@CSSModules(Styles)
export default class RecentBlogPosts extends Component {
  constructor(props){
    super(props)
  }
  render() {
    const posts = config.blog
    return (
      <div styleName='blog-wrapper'>
        <ContainerDivs>
          <Row>
            { /* for each post, a column */
              posts.map((item, i) => {
                return (
                  <Col xs={12} sm={12} md={4} key={i}>
                    <Link
                      to={config.links.blog + item.url}
                      title={item.title}
                    >
                      <div styleName='card'>
                        <div
                          styleName='card-img'
                          style={{
                            backgroundImage: 'url(' + item.image + ')',
                          }}
                        />
                        <div styleName='card-title'>
                          {item.title}
                        </div>
                        <div styleName='card-date'>
                          { moment(item.date).format('MMM D, YYYY') }
                        </div>
                        <div styleName='card-subtitle'>
                          {item.subtitle}
                        </div>
                      </div>
                    </Link>
                  </Col>
                )
              })
            }
          </Row>
          <div styleName='blog-more'>
            <Link
              to={config.links.blog}
              title='Fossil Free Funds Blog'
              roundbutton
            >
              More blog posts<LinkIcon />
            </Link>
          </div>
        </ContainerDivs>
      </div>
    )
  }
}